import './utils/dayjsConfig';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


// Perf: GTM is not needed for first paint/interaction and pulls in a
// render-blocking-adjacent script. Defer its init off the critical path —
// requestIdleCallback runs it once the browser is idle, with a timed
// setTimeout fallback for Safari (no requestIdleCallback support).
const loadAnalytics = () => {
  import('react-gtm-module').then(({ default: TagManager }) => {
    TagManager.initialize({ gtmId: 'GTM-PHH2KT' });
  });
};

const ldcConfig = window.ldcConfig || {};
if (ldcConfig.isloadGTM) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadAnalytics);
  } else {
    setTimeout(loadAnalytics, 2000);
  }
}

// ── Suppress "Script error." from cross-origin iframes (Stripe, GTM, etc.) ──
// These arrive with no filename/lineno due to CORS — React's dev overlay
// catches them via window.addEventListener('error') and shows a red panel.
// We intercept first using the capture phase (fires before bubble phase),
// which lets us silently drop them. Production is unaffected (no overlay there).
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', function suppressCrossOriginErrors(event) {
    if (event.message === 'Script error.' && !event.filename) {
      event.stopImmediatePropagation(); // don't let the overlay see it
      event.preventDefault();           // prevent default browser handling
    }
  }, true /* capture phase */);
}

if (process.env.REACT_APP_WIDGET_MODE === 'true') {
  // ✅ Widget Mode (react-app-rewired build)
  // console.log(" window.initialPath", window.initialPath);
  (function () {
    const container = document.getElementById('ldc-booking-engine');
    const ldcConfig = window.ldcConfig || {};
    const { initialPath = "/", productCategoryId, resheduleKey,stateCode,authCode,productId,clinicId,hashCode,partnerId,hideAdditionalPreferences } = ldcConfig;

    if (!container) {
      console.error(":x: MyReactWidget: <div id='ldc-booking-engine'> not found!");
    } else {
      const root = ReactDOM.createRoot(container);
      root.render(
        <React.StrictMode>
          <App initialPath={initialPath} productCategoryId={productCategoryId} resheduleKey={resheduleKey} stateCode={stateCode} authCode={authCode} productId={productId} clinicId={clinicId} hashCode={hashCode} partnerId={partnerId} hideAdditionalPreferences={hideAdditionalPreferences}/>
        </React.StrictMode>
      );
      // console.log(":white_check_mark: LDC Booking Engine rendered automatically");
    }
  })();
} else {
  // ✅ Normal CRA Mode (npm start / npm run build)
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <App />
  );
}

reportWebVitals();
